<template>
  <div class="cgw_bk_sk" style="height: 0px;">
    <el-row :gutter="40">
      <el-col :span="8">
        <el-form class="form" label-width="auto">
          <el-form-item>
            <el-text style="margin-right: 20px; font-size: larger; font-weight: bolder;">
              查岗位 - 本科及以上 - 省考
            </el-text>
          </el-form-item>
          <el-form-item label="省份选择">
            <el-button type="primary" @click="show.addProvince = true" style="margin-left: 20px;">添加</el-button>
          </el-form-item>
        </el-form>
        <el-table :data="data.provinces" border style="width: 100%; height: calc(100vh - 240px);" @row-click="(row) => { data.province = row.kkey; provinceChange() }">
          <el-table-column prop="kkey" label="省份" align="center" />
          <el-table-column label="操作" width="200" align="center">
            <template #default="scope">
              <el-button size="small" type="danger" @click="() => { data.province = scope.row.kkey; show.delProvince = true; }">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
      <el-col :span="16">
        <template v-if="data.province">
          <el-form class="form" label-width="auto">
            <el-form-item>
              <el-text style="margin-right: 20px; font-size: larger; font-weight: bolder;">
                当前编辑中：{{ data.province }}
              </el-text>
            </el-form-item>
          </el-form>
          <el-form-item label="文件">
            <el-upload :data="{ type: 'GW_BK_SK', kkey1: data.province }" style="width: 100%;" v-model:file-list="data.file.file" :limit="1" :action="api.baseURL() + '/backend/information/importExcel'" :headers="api.tokenHeader()" multiple drag :on-remove="remove"
              :on-success="() => ElMessage.success('上传成功')" :on-error="() => ElMessage.error('上传失败')" :on-preview="(f) => util.previewElfile(f)" accept=".xls,.xlsx">
              <el-text>点击或拖转到此处上传文件（最多1个）</el-text>
            </el-upload>
          </el-form-item>
        </template>
      </el-col>
    </el-row>
    <div style="height: 10px;"></div>
  </div>

  <el-dialog v-model="show.addProvince" title="添加省份" width="30%">
    <el-form :model="data" label-width="auto">
      <el-form-item label="请输入省份名称">
        <el-select v-model="data.addProvince.kkey" filterable style="width: 100%">
          <el-option v-for="item in provinces" :key="item" :label="item" :value="item" />
        </el-select>
      </el-form-item>
    </el-form>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="show.addProvince = false">取消</el-button>
        <el-button type="primary" @click="addProvince">确定</el-button>
      </span>
    </template>
  </el-dialog>

  <el-dialog v-model="show.delProvince" title="删除省份" width="30%">
    <el-text>确定删除当前省份吗？</el-text>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="show.delProvince = false">取消</el-button>
        <el-button type="primary" @click="delProvince">确定</el-button>
      </span>
    </template>
  </el-dialog>
</template>

<script setup>
import { reactive, } from 'vue'
import { useRouter } from 'vue-router'
import { ElMessage } from 'element-plus'
import api from '../../apis/api'
import cache from '../../utils/cache'
import util from '../../utils/util'
import Editor from '../../components/Editor.vue'

const router = useRouter()
const show = reactive({
  addProvince: false,
  delProvince: false,
})
const provinces = reactive(["北京市", "天津市", "河北省", "山西省", "内蒙古自治区", "辽宁省", "吉林省", "黑龙江省", "上海市", "江苏省", "浙江省", "安徽省", "福建省", "江西省", "山东省", "河南省", "湖北省", "湖南省", "广东省", "广西壮族自治区", "海南省", "重庆市", "四川省", "贵州省", "云南省", "西藏自治区", "陕西省", "甘肃省", "青海省", "宁夏回族自治区", "新疆维吾尔自治区", "台湾省", "香港特别行政区", "澳门特别行政区"])
const loading = reactive({
  save: false,
})
const data = reactive({
  provinces: [],
  province: '',
  addProvince: {},
  file: { file: [] },
})

/** 查询全部省份 */
const getProvinces = () => {
  api.get('/backend/kkv/getList', {
    params: {
      scene: 'GW_BK_SK_P'
    }
  }).then((res) => {
    if (res && res.list && res.list.length > 0) {
      data.provinces = []
      provinces.forEach((item) => {
        for (const i of res.list) {
          if (i.value === item) {
            data.provinces.push(i)
            break
          }
        }
      })
      if (!data.province) {
        data.province = res.list[0].kkey
        provinceChange()
      }
    } else {
      data.provinces = []
      data.province = ''
    }
  })
}
getProvinces()

/** 添加省份 */
const addProvince = () => {
  api.post('/backend/kkv/put', {
    scene: 'GW_BK_SK_P',
    kkey: data.addProvince.kkey,
    value: data.addProvince.kkey
  }).then(() => {
    ElMessage.success('添加成功')
    data.addProvince = {}
    show.addProvince = false
    getProvinces()
  })
}

const delProvince = () => {
  api.post('/backend/kkv/del', {
    scene: 'GW_BK_SK_P',
    kkey: data.province,
  }).then(() => {
    data.province = ''
    show.delProvince = false
    ElMessage.success('删除成功')
    getProvinces()
  })
}

/** 切换省份 */
const provinceChange = () => {
  data.file = { file: [] }
  api.get('/backend/kkv/getList', {
    params: {
      scene: 'GW_BK_SK',
    }
  }).then((res) => {
    if (res && res.list && res.list.length > 0) {
      console.log(res.list)
      const kkv = res.list.find((item) => item.kkey === data.province)
      if (kkv && kkv.value) {
        data.file.file = util.json2Elfile(JSON.stringify([kkv.value]))
      }
    }
  })
}

const remove = () => {
  api.post('/backend/information/remove', {
    type: 'GW_BK_SK',
    kkey1: data.province,
  }).then(() => {
    ElMessage.success('删除成功')
  })
}
</script>

<style lang="less">
.cgw_bk_sk {
  margin: auto;

  .avatar-uploaded {
    width: 178px;
    height: 178px;
    border: 1px dashed var(--el-border-color);
    border-radius: 6px;
    margin-right: 20px;
  }

  .avatar-uploader .el-upload {
    border: 1px dashed var(--el-border-color);
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    transition: var(--el-transition-duration-fast);
  }

  .avatar-uploader .el-upload:hover {
    border-color: var(--el-color-primary);
  }

  .el-icon.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    text-align: center;
  }
}
</style>